module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoUL.996de04.woff";